<template>
    <div class="has-text-left ">
        <page-title-display :pageTitle="'Create a new validation plan'"></page-title-display>

        <div style="margin-top:20px"></div>
        
        <!-- Page Content start -->
        <div class="tile is-ancestor">
            <div class="tile is-vertical is-parent">
                <!-- First section start -->
                <div class="tile is-child box">
                     <div class="columns is-mobile">
                        <div class="column">
                            <div class="block">
                                <div class="column">
                                    <b-field class="has-text-left" label="Validation plan Name">
                                        <b-input name="template_name" v-model="validationPlanTemplate.name" placeholder="Template Name"></b-input>
                                    </b-field>
                                </div>
                                <div class="column">
                                    <div class="field has-text-left">
                                        <label class="label">Comment</label>
                                        <div class="control">
                                            <textarea name="template_comment" class="textarea" v-model="validationPlanTemplate.comment" placeholder="Comment"></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div class="column">
                                    <div class="field has-text-left">
                                        <p class="p-input-label">Select a guideline for your validation plan</p>
                                        <b-radio name="guideline" class="box" v-for="guideline in guidelines" :key="guideline.id" v-model="guideLineSelection"
                                            :native-value="guideline">
                                            {{guideline.name}}{{hacky_guidelines}}
                                        </b-radio>
                                    </div>
                                </div>
                            </div>

                            <div  id="topActionBUttons" class="is-pulled-right">
                                <a class=" button is-primary" @click="nextToValidationParameter">
                                    <span>Continue</span>
                                </a>
                                <span style="margin-left:20px;"></span>
                                <a class="button" @click="$router.go(-1)">
                                    <span>Cancel</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- First section end --> 

                <!-- Second section start -->
                <div id="seconsSectionContent" class="tile is-child box">
                    <!-- Validation Parameters Start -->
                    <p class="subtitle p-input-label">Validation Parameters</p>


                    <div v-for="valParam in validationParameterSet" :key="valParam" >
                        <a class="button accordionButton is-large is-fullwidth" style="margin-top:20px" :id="valParam" v-on:click="accordionAction(valParam)">
                            <span>
                                {{valParam}}
                            </span>
                            <span class="icon is-small is-pulled-right">
                                <i class="fas fa-caret-down"></i>
                            </span>
                        </a>

                        <div class="tile is-ancestor contentOfAccordion">
                            <div class="tile is-parent">
                                <div class="tile is-child box">
                                    <div class="content has-text-left">
                                        <!-- content of Validation Parameter -->
                                        <div class="box has-background-white-ter" style="margin-bottom: 0.5rem;" v-for="assesmentMethod in guideLineSelection.assessment_methods" :key="assesmentMethod.id" v-if="assesmentMethod.validation_parameter_display == valParam">
                                            <p class="is-size-7 has-text-weight-bold">Assessment method</p>
                                            <div class="columns">
                                                <div class="field column">
                                                    <b-checkbox v-model="assessmentMethodcheckboxGroup"
                                                    :native-value="assesmentMethod">
                                                        {{assesmentMethod.name}}
                                                    </b-checkbox>
                                                </div>


                                                <!-- <span style="margin-left: 20px;"></span> -->

                                                <div class="column is-three-quarters">
                                                    <div class="" >
                                                        <p v-if="assesmentMethod.criteria[0]" class="is-size-7 has-text-weight-bold" style="padding-bottom:10px;">Criteria:</p>
                                                    </div>
                                                    <!-- criteria and value -->
                                                    <div class="tile is-ancestor" v-for="criteria in assesmentMethod.criteria" :key="criteria.id">
                                                        <div class="tile is-vertical is-parent"  style="padding-top:0px; padding-bottom:5px;">
                                                            <div class="tile is-child field columns">
                                                                <b-checkbox v-model="criteriaCheckboxGroup"
                                                                :native-value="criteria.id" v-on:input="onCriteriaSelection()">
                                                                    <span class="">{{criteria.name}}</span>
                                                                </b-checkbox>
                                                                <span style="margin-left: 20px;"></span>
                                                                <b-field class="has-text-left" >
                                                                    <b-input name="method_name" v-model="criteria.value" placeholder="Criterion Value"></b-input>
                                                                </b-field>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                          <div v-if="assesmentMethod.metadatas.length">
                                            <p class="is-size-7 has-text-weight-bold">Parameters</p>
                                            <metadata-component :metadata-list="assesmentMethod.metadatas" :editable="true"></metadata-component>
                                          </div>

                                        </div>
                                        <!-- /content of Validation Parameter -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Validation Parameters end --> 

                    <!-- Action buttons -->
                    <div class="column" style="margin-top:50px">
                        <span class="">
                            <a class="button is-primary is-large" @click="createValidationPlanTemplate()">
                                <span>Submit</span>
                            </a>
                            <span style="margin-left:20px"></span>
                            <!-- @click="$router.go(-1) takes you to previous router-link component :) -->
                            <a class="button is-large" @click="$router.go(-1)">
                                <span>Cancel</span>
                            </a>
                        </span>
                    </div>
                    <!-- Action buttons End --> 
                </div>
                <!-- Second section end -->
            </div>
        </div>
        <!-- Page Content end -->
    </div>
</template>


<script>
import axios from "axios"
import PageTitleDisplay from '@/components/features/displayElements/PageTitleDisplay'
import {mapGetters} from "vuex";
import MetadataParser from "@/valchrom/MetadataParser";
import MetadataComponent from "@/valchrom/common/metadata/MetadataComponent";
export default {
    name:'NewValidationPlanTemplateComponent',
    props: ["guidelines", "validationParameters"],
    components: {PageTitleDisplay,MetadataComponent},
    data() {
        return {
            // Tab vars
            guideLineSelection: '',
            activeTab:0,
            ValidParamDisabled: true,
            // ass meth
            validationParameterSet: [],
            assessmentMethodcheckboxGroup: [],
            criteriaCheckboxGroup: [],
            // data to return
            validationPlanTemplate: {
                name:'',
                comment:'',
                guideline:'',
                assessment_methods:[], // changed methods to assessment_methods
                criteria:[]
            }
        }
    },
    computed: {
      ...mapGetters ([
        'math_service_url','auth_header'
      ]),
      hacky_guidelines: function(){
        let defaultMetadataUrl = this.math_service_url+"all_am_metadata_types/";
        axios.get(defaultMetadataUrl,{
          headers: this.auth_header
        }).then(defaultMetadatas => {
              this.guidelines.forEach(guideline =>
                  MetadataParser.setDefaultMetadatas(defaultMetadatas.data, guideline.assessment_methods)
              )
              console.log(this.guidelines)
            }
        );
        return "";
      },
    },


    methods: {

        onCriteriaSelection: function() {
            let mainThis = this;
            setTimeout(ensureConstraints,10);

            function ensureConstraints() {

                let antescent1 = 'Back-calculated concentration - minimum per cent of levels passing';
                let antescent2 = 'Back-calculated concentration - minimum per cent of parallels passing per level';
                let consequent1 = 'Maximum back-calculated concentration error';
                let consequent2 = 'Maximum back-calculated concentration error for LoQ';
                var enable = false;
                mainThis.guideLineSelection.assessment_methods.every(function (assessmentMethod) {
                    return assessmentMethod.criteria.every(function (criteria) {
                        return mainThis.criteriaCheckboxGroup.every(function (criteriaId) {
                            if (criteriaId === criteria.id) {
                                let checkedCritera = criteria;
                                if (checkedCritera.name == antescent1 || checkedCritera.name == antescent2) {
                                    enable = true;
                                    return false; // stop the every loops
                                }
                            }
                            return true;
                        })
                    })
                });
                if (enable) {
                    mainThis.guideLineSelection.assessment_methods.forEach(function (assessmentMethod) {
                        assessmentMethod.criteria.forEach(function (criteria) {
                            if (criteria.name == consequent1 || criteria.name == consequent2) {
                                if (mainThis.criteriaCheckboxGroup.indexOf(criteria.id) == -1) {
                                    mainThis.criteriaCheckboxGroup.push(criteria.id);
                                }
                            }
                        })
                    });
                    // just in case remove cuplicates
                    mainThis.criteriaCheckboxGroup = [...new Set(mainThis.criteriaCheckboxGroup)];
                }
            }
        },
        nextToValidationParameter: function(){
                if(this.guideLineSelection.name) {
                    var seconsSectionContent = document.getElementById('seconsSectionContent')
                    seconsSectionContent.style.display = "block"
                    var topActionBUttons = document.getElementById('topActionBUttons')
                    topActionBUttons.style.display = "none"
                    this.showValidationParameter(this.guideLineSelection)
                } else {
                    this.$toast.open({
                        duration: 5000,
                        message: `Select a guideline for your validation plan`,
                        position: 'is-top',
                        type: 'is-danger'
                    })
                }
        },
        showValidationParameter: function(guideline) {
            this.validationParameterSet = new Set()
            var mainThis = this
            guideline.assessment_methods.forEach(function(assMethod) {
                mainThis.validationParameterSet.add(assMethod.validation_parameter_display)
            })
            this.validationParameterSet = Array.from(this.validationParameterSet)
            this.validationParameterSet.sort((a, b) => {return this.validationParameters.indexOf(a) - this.validationParameters.indexOf(b)})
            // console.log("sort validationParameters: ", this.validationParameters)
        },

        createValidationPlanTemplate: function(){
            var mainThis = this
            this.validationPlanTemplate.guideline =  this.guideLineSelection.name

            this.assessmentMethodcheckboxGroup.forEach(function(assessmentMethod){
                mainThis.validationPlanTemplate.assessment_methods.push(assessmentMethod.id)
            })            
            
            this.guideLineSelection.assessment_methods.forEach(function(assessmentMethod){
                assessmentMethod.criteria.forEach(function(criteria){
                    mainThis.criteriaCheckboxGroup.forEach(function(criteriaId){
                        if(criteriaId == criteria.id){
                            mainThis.validationPlanTemplate.criteria.push(criteria)
                        } 
                    })   
                })
            })

          this.validationPlanTemplate.ams = this.assessmentMethodcheckboxGroup;

          MetadataParser.setMetadataJsons(this.validationPlanTemplate)


            console.log("validationPlanTemplate content: ", this.validationPlanTemplate)


            this.$emit("createValidationPlanTemplate", this.validationPlanTemplate);
        },
        accordionAction: function(id) {
            var accordionButton = document.getElementById(id)
            var contentOfAccordion = document.getElementById(id).nextSibling
            // console.log("x.style.display", x) is-primary 
            if (contentOfAccordion.style.display == "block") {
                contentOfAccordion.style.display = "none"
                accordionButton.classList.remove("is-primary");
            } else if (contentOfAccordion.style.display == "none") {
                contentOfAccordion.style.display = "block"
                accordionButton.classList.add("is-primary");
            } else if(contentOfAccordion.style.display == "") {
                contentOfAccordion.style.display = "block"
                accordionButton.classList.add("is-primary");
            }

            // accordionButton class
            var otherAccordions = Array.from(document.getElementsByClassName("accordionButton"))
            // console.log("ohters...", otherAccordions)    
            otherAccordions.forEach(function(otherAccordionButton){
                if(accordionButton != otherAccordionButton){
                    var content = otherAccordionButton.nextSibling
                    content.style.display = "none"
                    otherAccordionButton.classList.remove("is-primary");
                }
                
            })

        }  

    }
}
</script>

<style scoped>
.contentOfAccordion{
    display: none;
}
#seconsSectionContent{
    display: none;
}
</style>
